import produce from "immer";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  createResourceHubFaqCategory,
  destroyResourceHubFaqCategory,
  fetchResourceHubFaqCategories,
  updateResourceHubFaqCategory,
} from "../../../api/resource-hub/faq/categories";

const initialState = {
  isLoading: false,
  error: false,
  errors: null,
  data: [],
  case: {},
  totalCount: 0,
  currentCount: 0,
};

export const initialController = {
  filters: [],
  page: 1,
  per_page: 200,
  query: "",
  sort: "desc",
  sortBy: "created_at",
  view: "all",
};

export const deleteResourceHubFaqCategoryAsync = createAsyncThunk(
  "resource_hub_faq_categories/deleteResourceHubFaqCategoryAsync",
  async (payload) => {
    let response = await destroyResourceHubFaqCategory(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // include the ID in the response
    response.id = payload.id;
    // If all good, return response.
    return response;
  }
);

export const createResourceHubFaqCategoryAsync = createAsyncThunk(
  "resource_hub_faq_categories/createResourceHubFaqCategoryAsync",
  async (payload) => {
    let response = await createResourceHubFaqCategory(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // If all good, return response.
    return response;
  }
);

export const updateResourceHubFaqCategoryAsync = createAsyncThunk(
  "resource_hub_faq_categories/updateResourceHubFaqCategoryAsync",
  async (payload, { rejectWithValue }) => {
    let response = await updateResourceHubFaqCategory(payload);
    // If errors, reject and return response
    if (response.response?.status?.match(/404|500|401/)) return rejectWithValue;

    // If all good, return response.
    return response;
  }
);
export const getResourceHubFaqCategoriesAsync = createAsyncThunk(
  "resource_hub_faq_categories/getResourceHubFaqCategoriesAsync",
  async (controller = initialController, { rejectWithValue }) => {
    // if (! controller) return false;
    let response = await fetchResourceHubFaqCategories(controller);
    // If errors, reject and return response
    if (response.response?.status?.match(/404|500|401/))
      return rejectWithValue(true);

    // If all good, return response.
    return response;
  }
);

const resourceHubFaqCategorySlice = createSlice({
  name: "resource_hub_faq_categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getResourceHubFaqCategoriesAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getResourceHubFaqCategoriesAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.totalCount = action.payload.totalCount;
        state.currentCount = action.payload.currentCount;
      })
      .addCase(getResourceHubFaqCategoriesAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.error = true;
        state.errors = [
          "Something went wrong when trying to fetch. Contact admin.",
        ];
      })
      .addCase(updateResourceHubFaqCategoryAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(updateResourceHubFaqCategoryAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          draftState.data = draftState.data.map((item) => {
            if (item.id === action.payload.id) {
              return action.payload;
            } else {
              return item;
            }
          });

          // draftState.case = action.payload;
          draftState.isLoading = false;
          draftState.error = false;
          draftState.errors = null;
        });
      })
      .addCase(updateResourceHubFaqCategoryAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.error = true;
        state.errors = [
          "Something went wrong when trying to update ResourceHubFaqCategory.",
        ];
      })
      .addCase(createResourceHubFaqCategoryAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(createResourceHubFaqCategoryAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          // push only if the item has no parent
          if (!action.payload.parent_id) {
            draftState.data.push(action.payload);
          }

          draftState.isLoading = false;
          draftState.error = false;
          draftState.errors = null;
        });
      })
      .addCase(createResourceHubFaqCategoryAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.error = true;
        state.errors = [
          "Something went wrong when trying to create ResourceHubFaqCategory.",
        ];
      })
      .addCase(deleteResourceHubFaqCategoryAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deleteResourceHubFaqCategoryAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          draftState.data = draftState.data.filter(
            (item) => item.id !== action.payload.id
          );
          draftState.isLoading = false;
          draftState.error = false;
          draftState.errors = null;
        });
      })
      .addCase(deleteResourceHubFaqCategoryAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.error = true;
        state.errors = [
          "Something went wrong when trying to delete ResourceHubFaqCategory.",
        ];
      });
  },
});

// export const {} = customerSlice.actions;

export const { reducer } = resourceHubFaqCategorySlice;

export default resourceHubFaqCategorySlice;
